import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SplitChildOrderDetail } from 'src/app/api/models/split-child-order-detail';

@Component({
    selector: 'app-child-csv-dialog',
    templateUrl: './child-csv-dialog.component.html',
    styleUrls: ['./child-csv-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ChildCsvDialogComponent {
  selectedChildOrder: number | null = null;

  constructor(
    public dialogRef: MatDialogRef<ChildCsvDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      childOrders: SplitChildOrderDetail[];
    }
  ) { }

  onConfirm(): void {
    this.dialogRef.close(this.selectedChildOrder);
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}